import { types } from "mobx-state-tree";
import { withReset } from "mobx-stores/_extension/with-reset";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";

export const DeleteConfirmationStore = types
  .model({
    open: false,
  })
  .actions(withSetPropAction)
  .actions(withReset)
  .volatile((self) => ({
    deletionCallback: () => {},
  }))
  .actions((self) => ({
    setDeletionCallback: (func: () => void) => {
      self.deletionCallback = func;
    },
  }));
